export { default as CoreMainModule } from './module';

export * from './containers/';
